import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { FIND, process } from '../Service/Api';

export const useFetchRoles = (queries = '', limit = 10, skip = 0) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getRoles = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND, 'roles', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar roles');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  const onChangeParams = (q = '', l = 10, s = 0) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getRoles();

  return [data, loading, onChangeParams, update];
};
